module.exports = __webpack_public_path__ + "static/img/4.bbe0ac3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/4.png
// module id = KkvJ
// module chunks = 0